import Rellax from 'rellax';

class Parallax {

    /**
     * @since 4.0.0
     * @method constructor
     */
    constructor() {
        // Run initialization
        this.init()
    }

    /**
     * Initialize the class.
     *
     * @method init
     * @since 4.0.0
     * @returns object The initialized map
     */
    init() {

        // Rellax
        if (document.getElementsByClassName('ll-parallax').length)
            var rellax = new Rellax('.ll-parallax', {
                speed:      -2.5,
                center:     false,
                wrapper:    null,
                round:      true,
                vertical:   true,
                horizontal: false,
            });

    }
}

export default Parallax;